import { CALL_STATES, SUB_BUTTON_ACTIONS } from "./../constants";

export const BASIC_CALL_ACTIONS_CONFIG = {
    [CALL_STATES.IDLE]:{
        buttonActions : []
    },
    [CALL_STATES.DIALING]:{
        buttonActions : [
            // SUB_BUTTON_ACTIONS.END,
            // SUB_BUTTON_ACTIONS.MUTE
        ]
    },
    [CALL_STATES.RINGING]:{
        buttonActions : [
            SUB_BUTTON_ACTIONS.END,
            // SUB_BUTTON_ACTIONS.MUTE
        ]
    },
    [CALL_STATES.IN_CALL]:{
        buttonActions : [
            SUB_BUTTON_ACTIONS.MUTE,
            SUB_BUTTON_ACTIONS.END
        ]
    },
    [CALL_STATES.ENDED]:{
        buttonActions : []
    }
}